import { Component, OnInit, Attribute, Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';


@Component({
    selector: 'app-section',
    templateUrl: './section.component.html',
    host: {'class': 'scrollTarget', 'ornament': 'ornament'}
})
export class SectionComponent implements OnInit {

    constructor(@Inject(PLATFORM_ID) private platform: any, @Attribute('ornament') public ornament='') { }

    ngOnInit() {

    }

    scroll() {
    }
}
